const config = {
	images: {
		imageSizes: [240, 480, 960, 1920],
		fallbackSize: 960,
	},
};

export default config;
